import { isHttpError } from '~shared/errors';

import { toast } from '@breezeventures/ui-kit/toast';

export const showErrorToast = (error: Error) => {
  let message = error.message || 'Request failed. Please try again.';

  if (isHttpError(error) && error.traceId) {
    message = `${message} (ID: ${error.traceId})`;
  }

  toast(message, {
    type: 'error',
    duration: 5000,
    dismissible: true,
    position: 'top-right',
  });
};
